import { ApplicationType, GpmFormula } from "../../../types/types";
import { calculateSumpGpm } from "./sump";
import { calculateSepticGpm } from "./septic";
import { calculateSewageGpm } from "./sewage";

export const GPM_FORMULAS: Partial<Record<ApplicationType, GpmFormula>> = {
	sump: calculateSumpGpm,
	septic: calculateSepticGpm,
	sewage: calculateSewageGpm,
};

export function getGpmFormula(
	applicationType: ApplicationType | null,
): GpmFormula | undefined {
	if (!applicationType) {
		return undefined;
	}

	return GPM_FORMULAS[applicationType];
}
